<template>
  <div class="perfectInformation" v-if="show">
    <div class="backdrop" @click.self="dismiss"></div>
    <div class="dialogContent" ref="dialogContent">
      <h2 :title="title">{{title}}</h2>
      <span class="close" @click="dismiss"><img src="/static/img/order-close.png" alt=""></span>
      <p>需要获取您的手机通讯录</p>
      <p>请您通过<span style="color: #0068b7">融资专家APP</span>提交您的手机通讯录信息</p>
      <div class="img-group">
        <!-- <div class="item pull-left">
          <img src="" alt="">
          <span>Ios下载</span>
        </div>
        <div class="item pull-right">
          <img src="" alt="">
          <span>Android下载</span>
        </div> -->
        <div class="item">
          <img src="/static/img/rzzj_downloaded.png" alt="融资专家APP">
          <span>APP下载</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      title: ''
    }
  },
  methods: {
    dismiss () {
      this.show = false
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../stylus/mixin'
.perfectInformation
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 1000
  .backdrop
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    background-color rgba(0, 0, 0, 0.5)
  .dialogContent
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    -ms-transform translate(-50%, -50%)
    width 460px
    background-color #fff
    padding 20px
    border-radius 4px
    .close
      opacity 0.5
      position absolute
      right 15px
      top 15px
      z-index 10
      &:hover
        opacity 1
      img
        display block
    h2, p
      margin 0
    h2
      font-size 26px
      color #0068b7
      text-decoration underline
      margin-bottom 18px
      padding-right 25px
      height 28px
      ellipsis()
    p
      font-size 20px
      color #333
      margin-bottom 5px
    .img-group
      width 352px
      height 170px
      margin 24px auto 0
      text-align center
      img
        display block
        margin 0 auto
        width 150px
        height 150px
        background-color #000
      span
        display block
        font-size 14px
        color #999
        padding-top 10px
</style>



// WEBPACK FOOTER //
// perfectInformation.vue?3d942004